<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsReseauxSociaux'
});
</script>
<template>
  <ka-container
    code="prog-08-reseaux-sociaux"
    :data="page.$info.prog08ReseauxSociaux">
    <!-- Page formation - V -->
    <ka-container code="page-formation-v">
      <PFormationEntete
        instance-class="p-formation-entete--p56"
        h-1="Formation en community management"
        texte="La formation est réalisée par un<strong> expert en community management</strong> issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <span v-html="t('prog08ReseauxSociaux.pageFormationV.containerExperts.titre.value', `Nos experts en réseaux sociaux`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog08ReseauxSociaux.pageFormationV.containerExperts.texte.value', `Le point de départ de nos formations est de faire matcher le profil idéal avec votre besoin afin que l’expert crée un parcours de formation adapté à votre équipe. Inutile de passer du temps à comprendre les rouages sur TikTok si votre entreprise n’a aucun intérêt stratégique à y être. Quel que soit le ou les réseaux sociaux sur lesquels vous souhaitez performer, nous avons forcément un expert qui vous apportera le coaching nécessaire pour y parvenir. Des experts en stratégie ou création de contenu, spécialistes de TikTok, Instagram, Twitter, Facebook et bien plus. Visez la lune, nous vous concocterons le parcours de formation idéal pour l’atteindre !`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p56"
            :options="{
              href: `https://www.matchers.fr/expert/457`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Responsable communication"
            first-name="Margaux"
            enttreprise="&#64;Michel & Augustin"
            image="https://ucarecdn.com/84b0ed35-ea9e-428f-86b8-979f6beacc0d/" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p56"
            :options="{
              href: `https://www.matchers.fr/expert/266`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element1Click
            }"
            :tags="page.$constants.element1Tags"
            poste="Head of video development"
            first-name="Julien"
            enttreprise="&#64;Splashr"
            image="https://ucarecdn.com/8e669394-781a-47bf-849e-948771f2db62/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p56"
            :options="{
              href: `https://www.matchers.fr/expert/194`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element2Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element2Tags"
            poste="Cheffe de projets marketing"
            first-name="Déborah"
            enttreprise="&#64;Cryostar"
            image="https://ucarecdn.com/660a2e6f-fb75-4140-a402-dc1dcd14144e/" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p56"
            :options="{
              href: `https://www.matchers.fr/expert/274`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element3Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element3Tags"
            poste="Graphiste et marketeuse"
            first-name="Joanna"
            enttreprise="&#64;Deleo"
            image="https://ucarecdn.com/83e3cf62-fe8b-4987-8b78-bb17cfcde041/" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog08ReseauxSociaux.pageFormationV.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog08ReseauxSociaux.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p56"
                  titre="I.   Choisir les bons médias sociaux en fonction de ses objectifs"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-1">
                <DropDownFormation
                  instance-class="element-4--p56"
                  titre="II.   Établir sa ligne éditoriale"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-5--p56"
                  titre="III.   Créer du contenu"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-3">
                <DropDownFormation
                  instance-class="element-6--p56"
                  titre="IV.   Animer les réseaux sociaux Facebook et Instagram"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p56" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p56"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p56" />
      <PFormationMatching
        instance-class="p-formation-matching--p56"
        description-company="<strong>Maison</strong> <strong>Gainville</strong> | Magasin de manteaux de fourrure.<br> <br> <br><strong>Besoin : </strong>Optimiser sa communication digitale pour générer des visites sur le point de vente.<br> "
        :expert-text="page.$constants.pFormationMatchingExpertText"
        budget-available="3 000€"
        training-hours="26h"
        photo-expert="https://ucarecdn.com/2a09d925-4a41-4dd3-95c7-bfdc53fe3989/"
        image="https://ucarecdn.com/eb94536b-6bca-4bef-9e87-cd419f042ab0/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p56" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p56" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsReseauxSociaux } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p56')
const appData = appDataStore()
const page = formationsReseauxSociaux()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
